'use client';

import { Tooltip as MuiTooltip, Box, Typography, Chip } from '@mui/material';
import React from 'react';

import { TooltipProps } from './types';

const isMac =
  typeof window !== 'undefined'
    ? navigator.platform.toUpperCase().indexOf('MAC') >= 0
    : false;

const ShortcutKey = ({ children }: { children: string }) => {
  if (children === 'Mod') {
    return (
      <Chip
        size='small'
        label={isMac ? '⌘' : 'Ctrl'}
        sx={{
          height: 20,
          minWidth: 20,
          fontSize: '0.625rem',
          fontWeight: 600,
          borderRadius: 1,
          border: 1,
          borderColor: 'divider',
          color: 'text.secondary',
          backgroundColor: 'background.paper',
        }}
      />
    );
  }

  if (children === 'Shift') {
    return (
      <Chip
        size='small'
        label='⇧'
        sx={{
          height: 20,
          minWidth: 20,
          fontSize: '0.625rem',
          fontWeight: 600,
          borderRadius: 1,
          border: 1,
          borderColor: 'divider',
          color: 'text.secondary',
          backgroundColor: 'background.paper',
        }}
      />
    );
  }

  if (children === 'Alt') {
    return (
      <Chip
        size='small'
        label={isMac ? '⌥' : 'Alt'}
        sx={{
          height: 20,
          minWidth: 20,
          fontSize: '0.625rem',
          fontWeight: 600,
          borderRadius: 1,
          border: 1,
          borderColor: 'divider',
          color: 'text.secondary',
          backgroundColor: 'background.paper',
        }}
      />
    );
  }

  return (
    <Chip
      size='small'
      label={children}
      sx={{
        height: 20,
        minWidth: 20,
        fontSize: '0.625rem',
        fontWeight: 600,
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        color: 'text.secondary',
        backgroundColor: 'background.paper',
      }}
    />
  );
};

export const Tooltip = ({
  children,
  enabled = true,
  title,
  shortcut,
}: TooltipProps) => {
  const tooltipContent = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {title && (
        <Typography
          variant='caption'
          sx={{ fontWeight: 500, color: 'text.secondary' }}
        >
          {title}
        </Typography>
      )}
      {shortcut && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {shortcut.map((shortcutKey) => (
            <ShortcutKey key={shortcutKey}>{shortcutKey}</ShortcutKey>
          ))}
        </Box>
      )}
    </Box>
  );

  if (enabled && (title || shortcut)) {
    return (
      <MuiTooltip
        title={tooltipContent}
        placement='top'
        arrow
        enterDelay={500}
        leaveDelay={0}
      >
        <Box component='span'>{children}</Box>
      </MuiTooltip>
    );
  }

  return <>{children}</>;
};

export default Tooltip;
